export const TOAST_THEMES = ['normal', 'info', 'success', 'warning', 'danger', 'utility'] as const;
